import { render, staticRenderFns } from "./convenioDetalhar.vue?vue&type=template&id=3f02e4d4"
import script from "./convenioDetalhar.vue?vue&type=script&lang=js"
export * from "./convenioDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports